export default __webpack_public_path__ + "static/media/gmail.4f10d6db.png";